import { render, staticRenderFns } from "./annualEducationPlanOld.vue?vue&type=template&id=1530904d"
import script from "./annualEducationPlanOld.vue?vue&type=script&lang=js"
export * from "./annualEducationPlanOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1530904d')) {
      api.createRecord('1530904d', component.options)
    } else {
      api.reload('1530904d', component.options)
    }
    module.hot.accept("./annualEducationPlanOld.vue?vue&type=template&id=1530904d", function () {
      api.rerender('1530904d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/annualEducationPlanOld.vue"
export default component.exports